import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Navigation, Car, Train } from 'lucide-react';

const MapSection = () => {
  return (
    <section className="py-20 bg-gray-50 relative">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-20 bg-white"></div>
      
      <div className="container mx-auto px-4">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="text-secondary uppercase tracking-wider font-semibold">La Nostra Sede</span>
          <h2 className="text-4xl font-monomakh text-primary mt-2 mb-4">Vieni a Trovarci</h2>
          <p className="text-gray-600 max-w-3xl mx-auto text-lg">
            La nostra agenzia è situata in una posizione strategica, facilmente accessibile 
            sia con i mezzi pubblici che in auto. Ti aspettiamo per una consulenza personalizzata.
          </p>
        </motion.div>
        
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-2xl shadow-2xl overflow-hidden max-w-5xl mx-auto"
        >
          <div className="h-[500px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2881.6!2d11.1786!3d43.7667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132a55d!2sVia+Pisana%2C+327%2C+50018+Scandicci+FI!5e0!3m2!1sen!2sit!4v1"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded-none"
              title="Mappa Molinaro Immobiliare"
            ></iframe>
          </div>
          
          <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black via-black/50 to-transparent h-48 pointer-events-none"></div>
          
          <div className="absolute bottom-8 right-8 md:bottom-10 md:right-10 z-10">
            <a 
              href="https://goo.gl/maps/LBMxRrbDG5xbDUTq9" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="flex items-center bg-white hover:bg-secondary text-primary hover:text-white font-semibold px-5 py-3 rounded-xl transition-all duration-300 shadow-lg transform hover:scale-105"
            >
              <Navigation className="h-5 w-5 mr-2" />
              Indicazioni Stradali
            </a>
          </div>
          
          <div className="absolute bottom-8 left-8 max-w-sm z-10">
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="flex mb-4 items-start">
                <MapPin className="h-6 w-6 text-secondary flex-shrink-0 mt-1 mr-3" />
                <div>
                  <h3 className="text-lg font-semibold text-primary mb-1">Molinaro Immobiliare</h3>
                  <p className="text-gray-700">Via Pisana 327, 50018 Scandicci (FI)</p>
                </div>
              </div>
              
              <div className="space-y-3 mt-4">
                <div className="flex items-center text-gray-700">
                  <Train className="h-5 w-5 text-gray-500 mr-2" />
                  <p className="text-sm">Dalla tramvia Resistenza (T1) 10 minuti a piedi</p>
                </div>
                <div className="flex items-center text-gray-700">
                  <Car className="h-5 w-5 text-gray-500 mr-2" />
                  <p className="text-sm">Ampio parcheggio gratuito disponibile nelle vicinanze</p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MapSection;